<template>
  <div>
    <head-nav-bar :title="title" :fixed="true"></head-nav-bar>
    <div class="report-box">
      <iframe
        :src="url"
        ref="iframe"
        style="height: calc(100vh - 50px);width:100%; "
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  components: {
    [Toast.name]: Toast,
  },
  data() {
    return {
      url: "",
      loading: true,
    };
  },
  created() {
    this.url = this.$route.query.reportUrl;
    this.title = this.$route.query.title;
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.report-box {
  margin-top: 46px;
}
</style>
